module.exports = __webpack_public_path__ + "img/nuform-logo.633512ce.png";